<template>
    <div class="container position-fixed fixed-header-wrapper header-container" data-agastya-ignore-deep>
        
        <div v-if="1==0" class="beta-banner position-relative" data-agastya-ignore>
            <div class="display-inline-block" style="vertical-align: text-bottom;">
                <svg width="52px" height="40px" viewBox="0 0 52 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
                    <title>Group 3@2x</title>
                    <desc>Created with Sketch.</desc>
                    <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Marketplace-GRID-simple" transform="translate(-52.000000, -10.000000)">
                            <g id="Group">
                                <g id="Group-3" transform="translate(52.000000, 10.000000)">
                                    <g id="hand_heart" transform="translate(8.695652, 5.217391)">
                                        <polygon id="Path-8" fill="#00AEEF" points="8.69565217 19.6135266 0.869565217 18.2608696 0.869565217 30.4347826 4.7826087 30.4347826"></polygon>
                                        <path d="M34.7063014,27.9750555 C33.6991245,25.9593464 31.4731911,24.9348031 29.2892838,25.479001 L24.5925064,26.6544685 C24.3838251,24.8419267 23.3128845,23.7723964 21.1681049,23.2340032 L8.60085594,20.4390027 C8.63998367,20.1632757 8.67041636,19.8991584 8.69215399,19.6539065 C8.71099327,19.4333249 8.62983945,19.2156458 8.46898098,19.0632704 C7.22703767,17.8849005 2.26071361,17.5046875 0.768062957,17.4147134 C0.565178402,17.4031039 0.372438075,17.4742124 0.227520536,17.6106247 C0.0826029972,17.747037 0,17.9385946 0,18.1388595 L0,31.1996096 C0,31.6001393 0.324615287,31.9252068 0.724587695,31.9252068 L5.07211386,31.9252068 C5.38513575,31.9252068 5.66337742,31.7234908 5.76047217,31.4245447 C5.77931145,31.3664969 5.87785538,31.0617461 6.02712045,30.5901079 L16.4104621,34.0555603 C17.6277694,34.5155889 18.4682912,34.7826087 19.4131535,34.7826087 C20.8811682,34.7826087 22.6027886,34.1382784 26.3880347,32.5884027 L34.3584993,28.9604165 C34.5367479,28.8791496 34.6758687,28.7282254 34.7410816,28.5424725 C34.8062945,28.3567196 34.7947011,28.15065 34.7063014,27.9750555 Z M4.54316485,30.4740124 L1.44772621,30.4740124 L1.44772621,18.9166997 C3.77655107,19.1010014 6.29087037,19.5015311 7.20385086,19.9455966 C6.81981938,23.1237124 5.08225809,28.7688589 4.54316485,30.4740124 Z M25.8112629,31.254755 C19.7160312,33.7566142 19.5059007,33.6797009 16.8959359,32.6885351 L6.45317801,29.202766 C7.0487891,27.2276904 7.87916659,24.2991799 8.35449612,21.8713316 L20.8347946,24.6489178 C22.4390317,25.0494475 23.085364,25.6836195 23.1737637,27.00856 L21.7825553,27.3553955 C21.2666488,27.486003 20.7174114,27.5005149 20.1942591,27.3945777 L13.9077362,26.1349409 C13.5150097,26.0551252 13.1338766,26.3119867 13.0556211,26.7052604 C12.9773656,27.0985341 13.2309713,27.4801982 13.6236978,27.5585627 L19.9116699,28.8181995 C20.2377343,28.8835032 20.5710447,28.9154295 20.9029058,28.9154295 C21.3188192,28.9154295 21.7361817,28.8646377 22.1361541,28.7630541 L24.0794983,28.276904 C24.0823966,28.276904 24.085295,28.276904 24.0881933,28.276904 L29.6399842,26.8866597 C30.9109111,26.5732017 32.1963296,27.0143648 32.9948253,27.9852139 L25.8112629,31.254755 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                                        <path d="M21.2159277,15.740035 L14.4134984,8.66110849 C13.5295014,7.7439536 13.0425785,6.52349906 13.0425785,5.22758241 C13.0425785,2.60527403 14.7279695,0.444445485 16.9625979,0.0656837319 C18.3204753,-0.160702603 19.689946,0.213705566 20.7348015,1.09893418 C21.1333247,1.43706249 21.4709826,1.83323858 21.73908,2.2729505 C22.0071775,1.83323858 22.3433862,1.43851369 22.7433586,1.09893418 C23.788214,0.213705566 25.1562356,-0.163604992 26.5155621,0.0656837319 C28.7472922,0.444445485 30.4326832,2.60527403 30.4326832,5.09262133 C30.4326832,6.52349906 29.9457603,7.7439536 29.0617633,8.66110849 L22.259334,15.740035 C22.1231115,15.8808009 21.9347187,15.9620678 21.7376308,15.9620678 C21.540543,15.9620678 21.3521502,15.8808009 21.2159277,15.740035 Z" id="Combined-Shape" fill="#E01098" fill-rule="nonzero"></path>
                                    </g>
                                    <g id="flaticon1507163315-svg" fill="#FFFFFF" fill-rule="nonzero">
                                        <path d="M3.48589554,19.0101989 L3.82944081,19.9416745 C3.84235526,19.9767433 3.87574383,20 3.91306973,20 C3.95039563,20 3.9837842,19.9767433 3.99669864,19.9416745 L4.34024391,19.0101989 C4.61832449,18.2561147 5.2127565,17.6616776 5.96678167,17.3836471 L6.89824924,17.0400989 C6.93326524,17.0271843 6.95652174,16.9937955 6.95652174,16.9564692 C6.95652174,16.919143 6.93326524,16.8857542 6.89824924,16.8728396 L5.96672918,16.5292914 C5.21270401,16.2512084 4.61827199,15.6568238 4.34024391,14.9027921 L3.99669864,13.9713165 C3.9837842,13.9363002 3.95039563,13.9130435 3.91306973,13.9130435 C3.87574383,13.9130435 3.84235526,13.9363002 3.82944081,13.9713165 L3.48589554,14.9027921 C3.20781496,15.6568238 2.61343545,16.2512084 1.85935778,16.5292914 L0.927837719,16.8728396 C0.89282172,16.8857542 0.869565217,16.919143 0.869565217,16.9564692 C0.869565217,16.9937955 0.89282172,17.0271843 0.927837719,17.0400989 L1.85930528,17.3836471 C2.61338295,17.6616776 3.20781496,18.2560622 3.48589554,19.0101989 Z" id="Shape"></path>
                                        <path d="M51.2460223,17.7423779 L50.3145992,17.3988792 C49.5605151,17.1207938 48.9660779,16.526404 48.6880474,15.7723658 L48.3444992,14.8408822 C48.3315846,14.8058656 48.2981958,14.7826087 48.2608696,14.7826087 C48.2235433,14.7826087 48.1901545,14.8058656 48.1772399,14.8408822 L47.8336917,15.7723133 C47.5556087,16.526404 46.9611716,17.1207938 46.2071399,17.3988792 L45.2756643,17.7423779 C45.240648,17.7552925 45.2173913,17.7886817 45.2173913,17.8260082 C45.2173913,17.8633348 45.240648,17.8967239 45.2756643,17.9096386 L46.2071924,18.2532423 C46.9612241,18.5313276 47.5556087,19.1257174 47.8336917,19.8797556 L48.1772399,20.8112917 C48.1901545,20.8463083 48.2235433,20.8695652 48.2608696,20.8695652 C48.2981958,20.8695652 48.3315846,20.8463083 48.3444992,20.8112917 L48.6880474,19.8797556 C48.9661304,19.1257174 49.5605151,18.5312751 50.3145467,18.2532423 L51.2460748,17.9096386 C51.2810911,17.8967239 51.3043478,17.8633348 51.3043478,17.8260082 C51.3043478,17.7886817 51.2810386,17.7552925 51.2460223,17.7423779 Z" id="Shape"></path>
                                        <path d="M22.5503701,2.95976916 L21.6189471,2.61627046 C20.8648629,2.33818508 20.2704257,1.74379532 19.9923953,0.989757137 L19.648847,0.0582735067 C19.6359325,0.023256904 19.6025436,0 19.5652174,0 C19.5278912,0 19.4945023,0.023256904 19.4815878,0.0582735067 L19.1380395,0.989704639 C18.8599565,1.74379532 18.2655194,2.33818508 17.5114877,2.61627046 L16.5800121,2.95976916 C16.5449958,2.97268382 16.5217391,3.00607297 16.5217391,3.04339951 C16.5217391,3.08072606 16.5449958,3.1141152 16.5800121,3.12702987 L17.5115402,3.47063357 C18.2655719,3.74871894 18.8599565,4.34310871 19.1380395,5.09714689 L19.4815878,6.02868301 C19.4945023,6.06369962 19.5278912,6.08695652 19.5652174,6.08695652 C19.6025436,6.08695652 19.6359325,6.06369962 19.648847,6.02868301 L19.9923953,5.09714689 C20.2704782,4.34310871 20.8648629,3.74866644 21.6188946,3.47063357 L22.5504226,3.12702987 C22.5854389,3.1141152 22.6086957,3.08072606 22.6086957,3.04339951 C22.6086957,3.00607297 22.5853865,2.97268382 22.5503701,2.95976916 Z" id="Shape-Copy"></path>
                                        <path d="M19.0887768,16.8967384 L18.4234075,16.65137 C17.884833,16.4527358 17.4602525,16.0281553 17.2616183,15.4895808 L17.0162499,14.8242667 C17.0069803,14.7992719 16.9831442,14.7826087 16.9564942,14.7826087 C16.9298441,14.7826087 16.906008,14.7992719 16.8967384,14.8242667 L16.6514252,15.4895256 C16.452791,16.0281553 16.0282105,16.4527358 15.4895808,16.65137 L14.8242667,16.8967384 C14.7992719,16.9059528 14.7826087,16.9297889 14.7826087,16.956439 C14.7826087,16.9830891 14.7992719,17.0069803 14.8242667,17.0161948 L15.489636,17.261508 C16.0282105,17.4601973 16.452791,17.8847778 16.6514252,18.4233523 L16.8967384,19.0887768 C16.906008,19.1137716 16.9298441,19.1304348 16.9564942,19.1304348 C16.9831442,19.1304348 17.0069803,19.1137716 17.0162499,19.0887768 L17.2616183,18.4233523 C17.4602525,17.8847227 17.8847778,17.4601973 18.4234075,17.2615631 L19.0887768,17.0161948 C19.1137716,17.0069803 19.1304348,16.9830891 19.1304348,16.956439 C19.1304348,16.9297889 19.1137716,16.9059528 19.0887768,16.8967384 Z" id="Shape"></path>
                                        <path d="M45.1840426,4.29995198 L44.6517294,4.10358273 C44.2208543,3.94467741 43.8812293,3.6050339 43.7223327,3.17419861 L43.5259742,2.64198287 C43.5186337,2.62198522 43.499523,2.60869565 43.4781976,2.60869565 C43.4568722,2.60869565 43.4377615,2.62198522 43.430421,2.64198287 L43.2340625,3.17419861 C43.0751658,3.60509718 42.7355409,3.94474069 42.3047291,4.10358273 L41.7724158,4.29995198 C41.7524193,4.30729289 41.7391304,4.32640456 41.7391304,4.34773116 C41.7391304,4.36905776 41.7524193,4.38816943 41.7724158,4.39551034 L42.3046658,4.5918796 C42.7356041,4.75078492 43.0752291,5.09049171 43.2341258,5.52139028 L43.4304843,6.05366931 C43.4378248,6.07366695 43.4569354,6.08695652 43.4782609,6.08695652 C43.4995863,6.08695652 43.5186969,6.07366695 43.5260374,6.05366931 L43.722396,5.52139028 C43.8812926,5.09049171 44.2209176,4.75078492 44.6518559,4.5918796 L45.1841059,4.39551034 C45.2041025,4.38816943 45.2173913,4.36905776 45.2173913,4.34773116 C45.2173913,4.32640456 45.2041025,4.30729289 45.1840426,4.29995198 Z" id="Shape"></path>
                                        <path d="M3.44491219,28.6478414 L2.91259893,28.4515354 C2.48172388,28.2926301 2.14209891,27.9529866 1.98326554,27.522088 L1.786907,26.9898722 C1.7795665,26.9698113 1.76045587,26.9565217 1.73913043,26.9565217 C1.717805,26.9565217 1.69869437,26.9698113 1.69135386,26.989809 L1.49505861,27.5219614 C1.33616196,27.95286 0.996473709,28.2925668 0.565598655,28.4514721 L0.0332853986,28.6477781 C0.0132888473,28.655119 0,28.6742306 0,28.6955572 C0,28.7168838 0.0132888473,28.7359955 0.0332853986,28.7433364 L0.565535374,28.9397057 C0.996473709,29.098611 1.33616196,29.4383178 1.49505861,29.8692796 L1.69135386,30.4014954 C1.69869437,30.421493 1.717805,30.4347826 1.73913043,30.4347826 C1.76045587,30.4347826 1.7795665,30.421493 1.786907,30.4014954 L1.98326554,29.8692164 C2.14216219,29.4382545 2.48178716,29.098611 2.9127255,28.939769 L3.44497547,28.7433997 C3.46497202,28.7360588 3.47826087,28.7169471 3.47826087,28.6956205 C3.47826087,28.6742939 3.46497202,28.6551823 3.44491219,28.6478414 Z" id="Shape"></path>
                                        <path d="M40.8362597,25.1695461 L40.3039755,24.9733355 C39.8731171,24.8144552 39.5334212,24.4747593 39.3744403,24.0438506 L39.1781794,23.5115664 C39.1707837,23.4915931 39.1517161,23.4782609 39.1303845,23.4782609 C39.1090529,23.4782609 39.0899852,23.4915931 39.0825896,23.5115664 L38.8863286,24.0438002 C38.7274484,24.474709 38.3877524,24.8144049 37.9567934,24.9733355 L37.4246098,25.1695461 C37.404536,25.1768914 37.3913043,25.1960094 37.3913043,25.217341 C37.3913043,25.2386726 37.4045863,25.2577906 37.4246098,25.2651359 L37.9568437,25.4614471 C38.3877021,25.6203274 38.727398,25.9600233 38.8863286,26.3909321 L39.0825896,26.9232162 C39.0899852,26.9432398 39.1090529,26.9565217 39.1303845,26.9565217 C39.1517161,26.9565217 39.170834,26.9432398 39.1781794,26.9232162 L39.3744906,26.3908817 C39.5333709,25.9600233 39.8730165,25.6203777 40.3039252,25.4614471 L40.8362597,25.2651359 C40.8562833,25.2577906 40.8695652,25.2386726 40.8695652,25.217341 C40.8695652,25.1960094 40.8563336,25.1768914 40.8362597,25.1695461 Z" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div class="display-inline-block">
                <p class="pl-2" style="line-height: 18px;">
                    {{t('This is a functional BETA version of Apprendo.')}} <br>
                   {{t('Here is a list of the functionality available in this version and about what is coming soon.')}}
                    <a href="http://help.apprendo.io/developers/roadmap" target="_blank">{{t('Learn More')}}</a>
                </p>
            </div>
            <button type="button" class="close" @click="closeBetaBanner()" aria-label="Close">
                <close-icon width="15" height="15" color="white"></close-icon>
            </button>
        </div>

        <div class="course container-top-line"
             :style="corporationStylesBorderTop">
            <div  :style="corporationStylesBorderTop"
                   class="header fixed-mobile clearfix">
                <nav data-agastya-ignore-deep>
                    <ul v-if="showSearch"
                        class="list-inline head p-sm-top hidden-xs">
                        <li class="stylish-input-group p-0-right">
                            <input @keyup.enter="doSearch({keyword: keyword}, true)"
                                   type="text"
                                   v-model="keyword" class="form-control"
                                   v-bind:placeholder="t('Search class, event, topics')"
                                   >
                        </li>
                        <li class="p-0-left">
                            <button @click="doSearch({keyword: keyword}, true)"
                                    type="button"
                                    class="btn btn-default white pull-right">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </li>
                    </ul>

                    <!-- Mobile search -->
                    <ul v-if="showSearch" style="left: 8px;"
                        :class="{'collapse-search': !showMobileSearch, 'login-view': isLoggedIn}"
                        class="list-inline head p-sm-top hidden-sm hidden-md hidden-lg">
                        <li class="p-0-left p-sm-right" v-if="showMobileSearch">
                            <svg width="15px" height="15px" @click="showMobileSearch = false;"
                                 viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs></defs>
                                <g id="Add-course-mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Template-TABS-Copy" transform="translate(-20.000000, -143.000000)" fill="#256AB3">
                                        <g id="header-copy" transform="translate(0.000000, 113.000000)">
                                            <g id="uikit/nav/search/active" transform="translate(20.000000, 20.000000)">
                                                <g id="uikit/icon/close/dark" transform="translate(0.000000, 10.000000)">
                                                    <g id="close">
                                                        <path d="M8.51721934,7.49988014 L14.7890531,1.22804634 C15.069996,0.947103476 15.069996,0.49165002 14.7890531,0.210707151 C14.5081103,-0.0702357171 14.0526568,-0.0702357171 13.7717139,0.210707151 L7.49988014,6.48254095 L1.22804634,0.211666001 C0.947103476,-0.0692768678 0.49165002,-0.0692768678 0.210707151,0.211666001 C-0.0702357171,0.492608869 -0.0702357171,0.948062325 0.210707151,1.22900519 L6.48254095,7.50083899 L0.211666001,13.7717139 C-0.0692768678,14.0526568 -0.0692768678,14.5081103 0.211666001,14.7890531 C0.35261686,14.9290451 0.535757091,15 0.719856173,15 C0.903955254,15 1.08805433,14.930004 1.22804634,14.7890531 L7.49988014,8.51721934 L13.7717139,14.7890531 C13.9126648,14.9290451 14.095805,15 14.2799041,15 C14.4640032,15 14.6481023,14.930004 14.7880943,14.7890531 C15.0690372,14.5081103 15.0690372,14.0526568 14.7880943,13.7717139 L8.51721934,7.49988014 Z" id="Shape" fill-rule="nonzero"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </li>
                        <li v-if="showMobileSearch"
                            class="stylish-input-group p-0-right p-0-left">
                            <input @keyup.enter="doSearch({keyword: keyword}, true)"
                                   style="width: calc(100vw - 110px);;margin-left: 0;border-color: #256ab3;"
                                   type="text" v-model="keyword" class="form-control"
                                   v-bind:placeholder="t('Search class, events, topics')">
                        </li>
                        <li class="p-xs-left" data-agastya-ignore>
                            <button @click="mobileSearchAction()"
                                    type="button"
                                    style="border-color: #256ab3;"
                                    class="btn btn-default white pull-right">
                                <span style="color: #256ab3;"
                                      class="glyphicon glyphicon-search"></span>
                            </button>
                        </li>
                    </ul>
                    <!-- End mobile search -->
                    <template v-if="!$parent.isLoggedIn">
                        <ul style="margin-left: 10px;"
                            class="nav nav-pills d-sm-flex pull-right p-sm-top">
                            <li class="mr-0">
                                <b-dropdown v-if="publicCatalogues.length > 0" variant="link" class="mr-2 d-none d-sm-block" id="public-catalogues-dropdown-simple">
                                    <template slot="button-content"><CatalogueIcon /></template>
                                    <b-dropdown-header><span class="font-weight-bolder text-uppercase">{{ t('Public Catalogues') }}</span></b-dropdown-header>
                                    <b-dropdown-item href="/" target="_blank"><span class="">{{ t('Marketplace') }}</span></b-dropdown-item>
                                    <b-dropdown-item :href="getCataloguePath(catalogue)" target="_blank" v-for="catalogue in publicCatalogues" :key="catalogue">
                                        {{ catalogue.category_name }}
                                    </b-dropdown-item>
                                </b-dropdown>
                                <b-tooltip custom-class="tooltip1" classes="tooltip1" target="public-catalogues-dropdown-simple" placement="left" triggers="hover">
                                    <span>{{ t('Public Catalogues') }}</span>
                                </b-tooltip>
                            </li>
                            <li role="presentation">
                                <a href="#" @click.prevent="$emit('open-login')" class="header-button-login btn btn-big btn-highlight">{{t('Log In / Sign Up')}}</a>
                            </li>
                            <li v-if="$parent.corporation.marketplace_show_register" role="presentation">
                                <a href="#" @click.prevent="$emit('open-signup')" class="header-button signup" >{{t('Register')}}</a>
                            </li>
                        </ul>
                        <ul class="nav nav-pills pull-right head d-none">
                            <li role="presentation">
                                <b-dropdown class="m-2 user-menu">
                                    <template slot="button-content">
                                        <svg width="30px" height="21px" viewBox="0 0 30 21"
                                             version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="MOBILE-Copy-3" transform="translate(-320.000000, -27.000000)" fill="#256AB3">
                                                    <g id="menu2" transform="translate(321.000000, 28.000000)">
                                                        <path d="M26.9951937,-0.402083333 C27.0990643,-0.389583333 27.1259593,-0.389583333 27.2279751,-0.36625 C27.495071,-0.30375 27.7389814,-0.16875 27.9216824,0.0179166667 C28.025553,0.124583333 28.1099479,0.24625 28.1683751,0.377916667 C28.2268023,0.50875 28.2601893,0.649583333 28.2676086,0.790416667 C28.2889392,1.25791667 28.0097869,1.70708333 27.5562804,1.93541667 C27.4180954,2.00375 27.267854,2.05208333 27.1129755,2.07541667 C27.0091049,2.09208333 26.9822098,2.08958333 26.8774118,2.09375 L0.909759065,2.09375 C0.804961038,2.08958333 0.778065969,2.09208333 0.675122774,2.07541667 C0.40246242,2.03375 0.146495558,1.91791667 -0.0528989188,1.74625 C-0.166971108,1.64791667 -0.261567557,1.53291667 -0.332051186,1.40625 C-0.403462231,1.28041667 -0.449833039,1.14291667 -0.470236195,1.00291667 C-0.525881165,0.612916667 -0.368220416,0.212916667 -0.0528989188,-0.05875 C0.0324233687,-0.132083333 0.127947234,-0.195416667 0.230890429,-0.247916667 C0.369075438,-0.31625 0.519316858,-0.364583333 0.675122774,-0.387916667 C0.778065969,-0.404583333 0.804961038,-0.402083333 0.909759065,-0.40625 L26.8774118,-0.40625 C26.9163633,-0.404583333 26.9562422,-0.402916667 26.9951937,-0.402083333 Z M26.9969863,8.34791667 C27.1008633,8.36041667 27.12776,8.36041667 27.229782,8.38375 C27.4968942,8.44625 27.7408195,8.58125 27.9235316,8.76791667 C28.0274086,8.87458333 28.1118086,8.99625 28.1702394,9.12791667 C28.3640812,9.56125 28.2666966,10.06875 27.9235316,10.4195833 C27.8196547,10.52625 27.6953733,10.61625 27.5581074,10.6854167 C27.4199139,10.75375 27.2696633,10.8020833 27.1147754,10.8254167 C27.0108984,10.8420833 26.9840017,10.8395833 26.8791973,10.84375 L0.909959184,10.84375 C0.805154759,10.8395833 0.778258048,10.8420833 0.675308568,10.8254167 C0.51949314,10.8020833 0.369242548,10.75375 0.231049102,10.6854167 C-0.150142214,10.4929167 -0.414471959,10.1420833 -0.470120327,9.75291667 C-0.484959891,9.64708333 -0.484959891,9.54041667 -0.470120327,9.43458333 C-0.449715925,9.29458333 -0.403342286,9.15708333 -0.331926881,9.03125 C-0.261438949,8.90458333 -0.166836724,8.78958333 -0.0527575714,8.69125 C0.146649078,8.51958333 0.402631568,8.40375 0.675308568,8.36208333 C0.778258048,8.34541667 0.805154759,8.34791667 0.909959184,8.34375 L26.8791973,8.34375 C26.9181511,8.34541667 26.9580325,8.34708333 26.9969863,8.34791667 Z M26.9969456,17.0979167 C27.1008259,17.1104167 27.1277235,17.1104167 27.2297488,17.13375 C27.4968695,17.19625 27.7408026,17.33125 27.9235206,17.5179167 C28.2666965,17.86875 28.3640843,18.37625 28.1702363,18.8095833 C28.1118036,18.94125 28.0274009,19.0629167 27.9235206,19.1695833 C27.8196403,19.27625 27.695355,19.36625 27.5580846,19.4354167 C27.4198868,19.50375 27.2696314,19.5520833 27.1147385,19.5754167 C27.0108582,19.5920833 26.9839606,19.5895833 26.8791528,19.59375 L0.909084052,19.59375 C0.804276275,19.5895833 0.777378703,19.5920833 0.674425931,19.5754167 C0.401740208,19.53375 0.14574953,19.4179167 -0.0536634978,19.24625 C-0.138993724,19.1729167 -0.21319392,19.0895833 -0.275336585,18.99875 C-0.505357194,18.6645833 -0.5452398,18.2420833 -0.381999367,17.8779167 C-0.32263921,17.74625 -0.239163989,17.6245833 -0.135283714,17.5179167 C-0.0314034388,17.41125 0.0928818904,17.32125 0.230152254,17.2520833 C0.36835012,17.18375 0.518605518,17.1354167 0.674425931,17.1120833 C0.777378703,17.0954167 0.804276275,17.0979167 0.909084052,17.09375 L26.8791528,17.09375 C26.9181079,17.0954167 26.9579905,17.0970833 26.9969456,17.0979167 Z" id="Combined-Shape"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </template>
                                    <b-dropdown-item @click="$emit('open-login')" id="#login-anchor">
                                        {{t('Log In / Sign Up')}}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </li>
                        </ul>
                    </template>

                    <a class="jfontsize-button" id="jfontsize-m2" href="#" style="display: none">A-</a>
                    <a class="jfontsize-button" ref="resetBtn" id="jfontsize-d2" href="#" style="display: none">A</a>
                    <a class="jfontsize-button" ref="fontUpBtn" id="jfontsize-p2" href="#" style="display: none">A+</a>

                    <ul class="nav nav-pills pull-right head" :class="{'hidden-xs': showMobileSearch}">
                        <template v-if="false && $parent.corporation.accessibility_on && !disableAccessibility">
                            <li class="acc-btn-li" v-if="fontIncreased"
                                v-tooltip="{placement: 'bottom', classes: 'fontBtn', content: '<p>'+t('Reset text')+'</p>'}"
                                @click="resetFont">
                                <svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Template-1-Copy" transform="translate(-777.000000, -27.000000)" fill="#214a58" fill-rule="nonzero">
                                            <g id="uikit/input/drop/select/menu" transform="translate(777.000000, 27.000000)">
                                                <g id="reset-text">
                                                    <path d="M16.5,0 C25.575,0 33,7.425 33,16.5 C33,25.575 25.575,33 16.5,33 C7.425,33 0,25.575 0,16.5 C0,7.425 7.425,0 16.5,0 Z M18.4319476,22.9818182 C18.0567673,22.9818182 18.0793651,22.9090909 17.9292929,22.8363636 C17.7792208,22.7636364 17.7792208,22.6909091 17.7792208,22.5454545 L17.7792208,9.01818182 L17.8542569,9.01818182 C18.7546898,9.01818182 19.4300144,9.09090909 19.955267,9.16363636 C20.4805195,9.23636364 20.8556999,9.30909091 21.0808081,9.45454545 C21.3809524,9.6 21.5310245,9.74545455 21.6810967,9.89090909 C21.8311688,10.1090909 21.9062049,10.3272727 21.981241,10.6181818 L22.5815296,13.0909091 L23.8571429,13.0909091 L23.8571429,8 L9.45021645,8 L9,13.0181818 L10.3506494,13.0181818 L11.1010101,10.2545455 C11.1760462,9.96363636 11.3261183,9.74545455 11.4011544,9.6 C11.5512266,9.45454545 11.7763348,9.30909091 12.0764791,9.23636364 C12.3766234,9.16363636 12.7518038,9.09090909 13.2770563,9.09090909 C13.8023088,9.09090909 14.4776335,9.01818182 15.3030303,9.01818182 L15.3780664,9.01818182 L15.3780664,22.5454545 C15.3780664,22.6909091 15.3030303,22.7636364 15.1529582,22.8363636 C15.002886,22.9090909 14.7777778,22.9818182 14.4025974,22.9818182 L12.7518038,23.1272727 L12.6767677,24 L18.6796537,24 L18.4319476,22.9818182 Z M24.7322075,17.3944687 L23.9301702,18.7287724 L28.7777778,18.0562834 L26.7726846,14 L25.9706474,15.3343037 C23.5173569,14.6297914 20.7809945,15.5691412 19.5071706,17.6933527 C19.2712773,18.0776322 19.106152,18.4832606 19,18.8888889 C20.1440826,17.0849102 22.6799357,16.4230956 24.7322075,17.3944687 Z M23.0455703,21.6055313 L23.8476076,20.2712276 L19,20.9437166 L21.0050932,25 L21.8071304,23.6656963 C24.2604209,24.3702086 26.9967833,23.4308588 28.2706072,21.3066473 C28.5065005,20.9223678 28.6716258,20.5167394 28.7777778,20.1111111 C27.6336952,21.9150898 25.0978421,22.5769044 23.0455703,21.6055313 Z" id="Combined-Shape"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </li>
                            <li class="acc-btn-li" v-else
                                v-tooltip="{placement: 'bottom', classes: 'fontBtn', content: '<p>'+t('Increase font size')+'</p>'}"
                                @click="increaceFont">
                                <svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
                                    <title>Increase Text</title>
                                    <desc>Created with Sketch.</desc>
                                    <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Marketplace-GRID-simple" transform="translate(-777.000000, -86.000000)" fill="#214a58" fill-rule="nonzero">
                                            <g id="uikit/input/drop/select/menu" transform="translate(777.000000, 86.000000)">
                                                <g id="Increase-Text">
                                                    <path d="M16.5,0 C25.575,0 33,7.425 33,16.5 C33,25.575 25.575,33 16.5,33 C7.425,33 0,25.575 0,16.5 C0,7.425 7.425,0 16.5,0 Z M18.6796537,22.9818182 C18.3044733,22.9818182 18.0793651,22.9090909 17.9292929,22.8363636 C17.7792208,22.7636364 17.7792208,22.6909091 17.7792208,22.5454545 L17.7792208,9.01818182 L17.8542569,9.01818182 C18.7546898,9.01818182 19.4300144,9.09090909 19.955267,9.16363636 C20.4805195,9.23636364 20.8556999,9.30909091 21.0808081,9.45454545 C21.3809524,9.6 21.5310245,9.74545455 21.6810967,9.89090909 C21.8311688,10.1090909 21.9062049,10.3272727 21.981241,10.6181818 L22.5815296,13.0909091 L23.8571429,13.0909091 L23.8571429,8 L9.45021645,8 L9,13.0181818 L10.3506494,13.0181818 L11.1010101,10.2545455 C11.1760462,9.96363636 11.3261183,9.74545455 11.4011544,9.6 C11.5512266,9.45454545 11.7763348,9.30909091 12.0764791,9.23636364 C12.3766234,9.16363636 12.7518038,9.09090909 13.2770563,9.09090909 C13.8023088,9.09090909 14.4776335,9.01818182 15.3030303,9.01818182 L15.3780664,9.01818182 L15.3780664,22.5454545 C15.3780664,22.6909091 15.3030303,22.7636364 15.1529582,22.8363636 C15.002886,22.9090909 14.7777778,22.9818182 14.4025974,22.9818182 L12.7518038,23.1272727 L12.6767677,24 L20.3304473,24 L20.2554113,23.1272727 L18.6796537,22.9818182 Z M25,19 L25,16 L23,16 L23,19 L20,19 L20,21 L23,21 L23,24 L25,24 L25,21 L28,21 L28,19 L25,19 Z" id="Combined-Shape"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </li>
                            <li class="acc-btn-li mr-0"
                                v-tooltip="{placement: 'bottom',
                                classes: 'fontBtn',
                                content: '<p>'+t('Select text and listen to it!')+'</p>'}">
                                <svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
                                    <title>sound</title>
                                    <desc>Created with Sketch.</desc>
                                    <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Marketplace-GRID-simple" transform="translate(-830.000000, -86.000000)" fill="#214a58" fill-rule="nonzero">
                                            <g id="uikit/input/drop/select/menu" transform="translate(777.000000, 86.000000)">
                                                <g id="sound" transform="translate(53.000000, 0.000000)">
                                                    <path d="M16.5,0 C25.575,0 33,7.425 33,16.5 C33,25.575 25.575,33 16.5,33 C7.425,33 0,25.575 0,16.5 C0,7.425 7.425,0 16.5,0 Z M19.721101,7.05389615 C19.5088019,6.95501955 19.2965029,7.00445785 19.1372786,7.10333445 L14.3074757,10.9595221 L9.53074757,10.9595221 C9.21229903,10.9595221 9,11.1572753 9,11.4539051 L9,20.5505528 C9,20.8471826 9.21229903,21.0449358 9.53074757,21.0449358 L14.3074757,21.0449358 L19.1372786,24.9011234 C19.2434281,25 19.3495777,25 19.4557272,25 C19.5088019,25 19.6149514,25 19.6680262,24.9505617 C19.8803252,24.8516851 19.9864747,24.7033702 19.9864747,24.505617 L19.9864747,7.49884088 C20.0395495,7.30108766 19.9334,7.15277276 19.721101,7.05389615 Z M21.4764397,20.5876964 C21.1778329,20.7692443 21.1181115,21.1323402 21.2375543,21.4349201 C21.356997,21.616468 21.5361611,21.7375 21.7750465,21.7375 C21.8944892,21.7375 21.9542106,21.7375 22.0736533,21.676984 C23.8652941,20.6482124 25,18.6511851 25,16.5936419 C25,14.4755826 23.8652941,12.5390713 22.0736533,11.5102997 C21.7750465,11.3287518 21.4167183,11.4497837 21.2375543,11.7523636 C21.0583902,12.0549435 21.1778329,12.4180394 21.4764397,12.5995873 C22.9097524,13.446811 23.8055728,14.9597104 23.8055728,16.6541578 C23.8055728,18.2275733 22.9097524,19.7404727 21.4764397,20.5876964 Z" id="Combined-Shape"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </li>
                        </template>

                        <template v-if="$parent.isLoggedIn && user">
                            <li role="presentation">
                                <b-dropdown v-if="catalogues.length>0 && 1==0" id="menu-catalogues" class="btn-catalogues user-menu float-left">
                                    <template slot="button-content">

                                        <div class="d-none d-sm-block">


                                            <svg width="27" height="28" xmlns="http://www.w3.org/2000/svg">
                                            	<g fill="none" fill-rule="evenodd"><g><path d="M0 .67C0 .3.316 0 .706 0h18.588c.39 0 .706.3.706.67v21.66c0 .37-.316.67-.706.67H.706C.316 23 0 22.7 0 22.33V.67z" fill="#256AB3"/><circle fill="#FFF" cx="1.848" cy="1.424" r="1"/><circle fill="#FFF" cx="3.587" cy="1.424" r="1"/><circle fill="#FFF" cx="5.543" cy="1.424" r="1"/><path fill="#FFF" d="M1.304 2.848v18.838h17.392V2.848z"/><path d="M3.716 16.329a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zm0 3.385a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zM3.313 5.496c0-.374.3-.677.673-.677h12.111c.372 0 .673.303.673.677v6.77a.675.675 0 01-.673.678H3.986a.675.675 0 01-.673-.677v-6.77z" fill="#256AB3"/></g><g transform="translate(7 5)"><path d="M0 .67C0 .3.316 0 .706 0h18.588c.39 0 .706.3.706.67v21.66c0 .37-.316.67-.706.67H.706C.316 23 0 22.7 0 22.33V.67z" fill="#256AB3"/><circle fill="#FFF" cx="1.848" cy="1.424" r="1"/><circle fill="#FFF" cx="3.587" cy="1.424" r="1"/><circle fill="#FFF" cx="5.543" cy="1.424" r="1"/><path fill="#FFF" d="M1.304 2.848v18.838h17.392V2.848z"/><path d="M3.716 16.329a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zm0 3.385a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zM3.313 5.496c0-.374.3-.677.673-.677h12.111c.372 0 .673.303.673.677v6.77a.675.675 0 01-.673.678H3.986a.675.675 0 01-.673-.677v-6.77z" fill="#256AB3"/></g></g>
                                            </svg>
                                        </div>
                                        <div class="d-block d-sm-none">
                                            <svg width="30px" height="21px" viewBox="0 0 30 21"
                                                 version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <g id="Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <g id="MOBILE-Copy-3" transform="translate(-320.000000, -27.000000)" fill="#256AB3">
                                                        <g id="menu2" transform="translate(321.000000, 28.000000)">
                                                            <path d="M26.9951937,-0.402083333 C27.0990643,-0.389583333 27.1259593,-0.389583333 27.2279751,-0.36625 C27.495071,-0.30375 27.7389814,-0.16875 27.9216824,0.0179166667 C28.025553,0.124583333 28.1099479,0.24625 28.1683751,0.377916667 C28.2268023,0.50875 28.2601893,0.649583333 28.2676086,0.790416667 C28.2889392,1.25791667 28.0097869,1.70708333 27.5562804,1.93541667 C27.4180954,2.00375 27.267854,2.05208333 27.1129755,2.07541667 C27.0091049,2.09208333 26.9822098,2.08958333 26.8774118,2.09375 L0.909759065,2.09375 C0.804961038,2.08958333 0.778065969,2.09208333 0.675122774,2.07541667 C0.40246242,2.03375 0.146495558,1.91791667 -0.0528989188,1.74625 C-0.166971108,1.64791667 -0.261567557,1.53291667 -0.332051186,1.40625 C-0.403462231,1.28041667 -0.449833039,1.14291667 -0.470236195,1.00291667 C-0.525881165,0.612916667 -0.368220416,0.212916667 -0.0528989188,-0.05875 C0.0324233687,-0.132083333 0.127947234,-0.195416667 0.230890429,-0.247916667 C0.369075438,-0.31625 0.519316858,-0.364583333 0.675122774,-0.387916667 C0.778065969,-0.404583333 0.804961038,-0.402083333 0.909759065,-0.40625 L26.8774118,-0.40625 C26.9163633,-0.404583333 26.9562422,-0.402916667 26.9951937,-0.402083333 Z M26.9969863,8.34791667 C27.1008633,8.36041667 27.12776,8.36041667 27.229782,8.38375 C27.4968942,8.44625 27.7408195,8.58125 27.9235316,8.76791667 C28.0274086,8.87458333 28.1118086,8.99625 28.1702394,9.12791667 C28.3640812,9.56125 28.2666966,10.06875 27.9235316,10.4195833 C27.8196547,10.52625 27.6953733,10.61625 27.5581074,10.6854167 C27.4199139,10.75375 27.2696633,10.8020833 27.1147754,10.8254167 C27.0108984,10.8420833 26.9840017,10.8395833 26.8791973,10.84375 L0.909959184,10.84375 C0.805154759,10.8395833 0.778258048,10.8420833 0.675308568,10.8254167 C0.51949314,10.8020833 0.369242548,10.75375 0.231049102,10.6854167 C-0.150142214,10.4929167 -0.414471959,10.1420833 -0.470120327,9.75291667 C-0.484959891,9.64708333 -0.484959891,9.54041667 -0.470120327,9.43458333 C-0.449715925,9.29458333 -0.403342286,9.15708333 -0.331926881,9.03125 C-0.261438949,8.90458333 -0.166836724,8.78958333 -0.0527575714,8.69125 C0.146649078,8.51958333 0.402631568,8.40375 0.675308568,8.36208333 C0.778258048,8.34541667 0.805154759,8.34791667 0.909959184,8.34375 L26.8791973,8.34375 C26.9181511,8.34541667 26.9580325,8.34708333 26.9969863,8.34791667 Z M26.9969456,17.0979167 C27.1008259,17.1104167 27.1277235,17.1104167 27.2297488,17.13375 C27.4968695,17.19625 27.7408026,17.33125 27.9235206,17.5179167 C28.2666965,17.86875 28.3640843,18.37625 28.1702363,18.8095833 C28.1118036,18.94125 28.0274009,19.0629167 27.9235206,19.1695833 C27.8196403,19.27625 27.695355,19.36625 27.5580846,19.4354167 C27.4198868,19.50375 27.2696314,19.5520833 27.1147385,19.5754167 C27.0108582,19.5920833 26.9839606,19.5895833 26.8791528,19.59375 L0.909084052,19.59375 C0.804276275,19.5895833 0.777378703,19.5920833 0.674425931,19.5754167 C0.401740208,19.53375 0.14574953,19.4179167 -0.0536634978,19.24625 C-0.138993724,19.1729167 -0.21319392,19.0895833 -0.275336585,18.99875 C-0.505357194,18.6645833 -0.5452398,18.2420833 -0.381999367,17.8779167 C-0.32263921,17.74625 -0.239163989,17.6245833 -0.135283714,17.5179167 C-0.0314034388,17.41125 0.0928818904,17.32125 0.230152254,17.2520833 C0.36835012,17.18375 0.518605518,17.1354167 0.674425931,17.1120833 C0.777378703,17.0954167 0.804276275,17.0979167 0.909084052,17.09375 L26.8791528,17.09375 C26.9181079,17.0954167 26.9579905,17.0970833 26.9969456,17.0979167 Z" id="Combined-Shape"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </template>
                                    <b-dropdown-item  >
                                        <b>{{t('Public Catalogues')}}</b>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="showDefaultMarketplace" href="/marketplace/index" >
                                        Marketplace
                                    </b-dropdown-item>
                                    <b-dropdown-item :href="'/'+catalogue.category_path" v-for="catalogue in catalogues">
                                        {{catalogue.category_name}}
                                    </b-dropdown-item>
                                </b-dropdown>

                                <b-dropdown v-if="publicCatalogues.length > 0" variant="link" class="float-left mt-2 mr-2 d-none d-sm-block" toggle-class="py-1" id="public-catalogues-dropdown">
                                    <template slot="button-content"><CatalogueIcon /></template>
                                    <b-dropdown-header><span class="font-weight-bolder text-uppercase">{{ t('Public Catalogues') }}</span></b-dropdown-header>
                                    <b-dropdown-item href="/" target="_blank"><span class="">{{ t('Marketplace') }}</span></b-dropdown-item>
                                    <b-dropdown-item :href="getCataloguePath(catalogue)" target="_blank" v-for="catalogue in publicCatalogues" :key="catalogue">
                                        {{ catalogue.category_name }}
                                    </b-dropdown-item>
                                </b-dropdown>
                                <b-tooltip custom-class="tooltip1" target="public-catalogues-dropdown" placement="left" triggers="hover">
                                    <span>{{ t('Public Catalogues') }}</span>
                                </b-tooltip>

                                <a :href="EVENTS_LINK()" class="d-none d-sm-block float-left mt-2 btn btn-highlight" v-if="isLearner || isAdminUser">{{t('My Events')}}</a>
                                
                                <a :href="MANAGES_LINK()" class="d-none d-sm-block float-left mt-2 btn btn-highlight" v-if="isExternalInstructor">{{t('Manage')}}</a>

                                <!--span class="btn-separator float-left d-none d-sm-block"></span-->

                                <b-dropdown id="menu-buttons" class="btn-user-menu user-menu">
                                    <template slot="button-content">
                                        <div>
                                            <img v-if="userData.profileImage" :src="userData.profileImage" alt="profile image"
                                                 class="rounded-circle avatar-img mt-0">
                                            <img v-else src="/webroot/images/user_placeholder.jpg"
                                                 alt="profile image"
                                                 class="rounded-circle avatar-img mt-0 mr-2 alternative">
                                            <span class="d-none d-lg-inline-block">
                                                {{user.first_name}} <span class="d-none">{{user.last_name}}</span>
                                            </span>
                                        </div>
                                    </template>

                                    <b-dropdown-text class="user-card">
                                      <a :href="PROFILES_LINK()" class="a-img">
                                        <img v-if="userData.profileImage" :src="userData.profileImage" alt="profile image"
                                             class="rounded-circle avatar-img">
                                        <img v-else src="/webroot/images/user_placeholder.jpg"
                                             alt="profile image"
                                             class="rounded-circle avatar-img alternative">
                                      </a>
                                      <div class="txt-secondary">
                                        {{t('Hello')}},
                                        <a :href="PROFILES_LINK()" class="my-name" :title="user.first_name">
                                            {{user.first_name}}
                                        </a><br>
                                        <!-- ROLE -->
                                        <span class="user-role txt-secondary" v-if="isOwner">{{t('Account Owner')}}</span>
                                        <span class="user-role txt-secondary" v-else-if="isCourseManager">{{t('Manager')}}</span>
                                        <span class="user-role txt-secondary" v-else-if="isExternalInstructor">{{t('Instructor')}}</span>
                                        <span class="user-role txt-secondary" v-else="isLearner">{{t('Attendee')}}</span>
                                        <!-- /ROLE -->

                                      </div>
                                    </b-dropdown-text>
                                    <template v-if="isOwner || isCourseManager">
                                        <b-dropdown-text class="role-secction pt-3 pb-4">
                                            <b>{{t('ROLE SECTIONS')}}</b>
                                        </b-dropdown-text>
                                        <b-dropdown-item :href="CREATES_LINK()">
                                            {{t('Create')}}
                                        </b-dropdown-item>
                                        <b-dropdown-item :href="MANAGES_LINK()">
                                            {{t('Manage')}}
                                        </b-dropdown-item>
                                        <b-dropdown-item :href="isOwner?ANALITICS_LINK():ANALITICS2_LINK()">
                                            {{t('Analytics')}}
                                        </b-dropdown-item>
                                        <b-dropdown-item :href="DOMAINS_LINK()" v-if="isOwner">
                                            {{t('Domain')}}
                                        </b-dropdown-item>
                                        <b-dropdown-divider class="divider" />
                                    </template>
                                    <template v-if="isExternalInstructor">
                                        <b-dropdown-text class="role-secction pt-3 pb-4">
                                            {{t('ROLE SECTIONS')}}
                                        </b-dropdown-text>
                                        <b-dropdown-item :href="MANAGES_LINK()">
                                            {{t('Manage')}}
                                        </b-dropdown-item>
                                        <b-dropdown-divider class="divider" />
                                    </template>

                                    <b-dropdown-text class="role-secction pt-3 pb-4"><b>{{t('MY ACCOUNT')}}</b></b-dropdown-text>
                                    <b-dropdown-item :href="EVENTS_LINK()">
                                        {{t('My Events')}}
                                    </b-dropdown-item>
                                    <b-dropdown-item :href="`${APLICATIONS_LINK()}${showApplications ? 'applications' : 'requests'}`" v-if="showApplicationsOption && (showApplications || showRequests)">
                                        {{t('Applications')}}
                                    </b-dropdown-item>
                                    <template v-if='show_my_preferences'>
                                    <b-dropdown-item :href="PREFERENCES_LINK()">
                                        {{t('Preferences')}}
                                    </b-dropdown-item>
                                    </template>
                                    <template v-else>
                                    <b-dropdown-item :href="FAVORITS_LINK()">
                                        {{t('My Favorites')}}
                                    </b-dropdown-item>
                                    </template>
                                    <b-dropdown-item :href="PROFILES_LINK()">
                                        {{t('Profile')}}
                                    </b-dropdown-item>
                                    <b-dropdown-item :href="ORDERS_LINK()">
                                        {{t('My Orders')}}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="logoutAction()" class="logout txt-link mt-2">
                                        {{t('Log out')}}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </li>
                        </template>

                    </ul>
                </nav>

                <div v-if="!$parent.isLoggedIn" class="hidden-sm hidden-md hidden-lg" :class="{'hidden-xs': showMobileSearch}">
                    	 <b-dropdown v-if="catalogues.length>0 && 1==0" id="menu-catalogues" class="m-2 user-menu float-right" style="left: 15px;">
                                    <template slot="button-content">

                                        <div class="d-none d-sm-block">


                                            <svg width="27" height="28" xmlns="http://www.w3.org/2000/svg">
                                            	<g fill="none" fill-rule="evenodd"><g><path d="M0 .67C0 .3.316 0 .706 0h18.588c.39 0 .706.3.706.67v21.66c0 .37-.316.67-.706.67H.706C.316 23 0 22.7 0 22.33V.67z" fill="#256AB3"/><circle fill="#FFF" cx="1.848" cy="1.424" r="1"/><circle fill="#FFF" cx="3.587" cy="1.424" r="1"/><circle fill="#FFF" cx="5.543" cy="1.424" r="1"/><path fill="#FFF" d="M1.304 2.848v18.838h17.392V2.848z"/><path d="M3.716 16.329a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zm0 3.385a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zM3.313 5.496c0-.374.3-.677.673-.677h12.111c.372 0 .673.303.673.677v6.77a.675.675 0 01-.673.678H3.986a.675.675 0 01-.673-.677v-6.77z" fill="#256AB3"/></g><g transform="translate(7 5)"><path d="M0 .67C0 .3.316 0 .706 0h18.588c.39 0 .706.3.706.67v21.66c0 .37-.316.67-.706.67H.706C.316 23 0 22.7 0 22.33V.67z" fill="#256AB3"/><circle fill="#FFF" cx="1.848" cy="1.424" r="1"/><circle fill="#FFF" cx="3.587" cy="1.424" r="1"/><circle fill="#FFF" cx="5.543" cy="1.424" r="1"/><path fill="#FFF" d="M1.304 2.848v18.838h17.392V2.848z"/><path d="M3.716 16.329a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zm0 3.385a.675.675 0 01-.673-.677c0-.374.302-.677.673-.677h12.785c.372 0 .673.303.673.677a.675.675 0 01-.673.677H3.716zM3.313 5.496c0-.374.3-.677.673-.677h12.111c.372 0 .673.303.673.677v6.77a.675.675 0 01-.673.678H3.986a.675.675 0 01-.673-.677v-6.77z" fill="#256AB3"/></g></g>
                                            </svg>
                                        </div>
                                        <div class="d-block d-sm-none">
                                            <svg width="30px" height="22px" viewBox="0 0 30 21"
                                                 version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <g id="Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <g id="MOBILE-Copy-3" transform="translate(-320.000000, -27.000000)" fill="#256AB3">
                                                        <g id="menu2" transform="translate(321.000000, 28.000000)">
                                                            <path d="M26.9951937,-0.402083333 C27.0990643,-0.389583333 27.1259593,-0.389583333 27.2279751,-0.36625 C27.495071,-0.30375 27.7389814,-0.16875 27.9216824,0.0179166667 C28.025553,0.124583333 28.1099479,0.24625 28.1683751,0.377916667 C28.2268023,0.50875 28.2601893,0.649583333 28.2676086,0.790416667 C28.2889392,1.25791667 28.0097869,1.70708333 27.5562804,1.93541667 C27.4180954,2.00375 27.267854,2.05208333 27.1129755,2.07541667 C27.0091049,2.09208333 26.9822098,2.08958333 26.8774118,2.09375 L0.909759065,2.09375 C0.804961038,2.08958333 0.778065969,2.09208333 0.675122774,2.07541667 C0.40246242,2.03375 0.146495558,1.91791667 -0.0528989188,1.74625 C-0.166971108,1.64791667 -0.261567557,1.53291667 -0.332051186,1.40625 C-0.403462231,1.28041667 -0.449833039,1.14291667 -0.470236195,1.00291667 C-0.525881165,0.612916667 -0.368220416,0.212916667 -0.0528989188,-0.05875 C0.0324233687,-0.132083333 0.127947234,-0.195416667 0.230890429,-0.247916667 C0.369075438,-0.31625 0.519316858,-0.364583333 0.675122774,-0.387916667 C0.778065969,-0.404583333 0.804961038,-0.402083333 0.909759065,-0.40625 L26.8774118,-0.40625 C26.9163633,-0.404583333 26.9562422,-0.402916667 26.9951937,-0.402083333 Z M26.9969863,8.34791667 C27.1008633,8.36041667 27.12776,8.36041667 27.229782,8.38375 C27.4968942,8.44625 27.7408195,8.58125 27.9235316,8.76791667 C28.0274086,8.87458333 28.1118086,8.99625 28.1702394,9.12791667 C28.3640812,9.56125 28.2666966,10.06875 27.9235316,10.4195833 C27.8196547,10.52625 27.6953733,10.61625 27.5581074,10.6854167 C27.4199139,10.75375 27.2696633,10.8020833 27.1147754,10.8254167 C27.0108984,10.8420833 26.9840017,10.8395833 26.8791973,10.84375 L0.909959184,10.84375 C0.805154759,10.8395833 0.778258048,10.8420833 0.675308568,10.8254167 C0.51949314,10.8020833 0.369242548,10.75375 0.231049102,10.6854167 C-0.150142214,10.4929167 -0.414471959,10.1420833 -0.470120327,9.75291667 C-0.484959891,9.64708333 -0.484959891,9.54041667 -0.470120327,9.43458333 C-0.449715925,9.29458333 -0.403342286,9.15708333 -0.331926881,9.03125 C-0.261438949,8.90458333 -0.166836724,8.78958333 -0.0527575714,8.69125 C0.146649078,8.51958333 0.402631568,8.40375 0.675308568,8.36208333 C0.778258048,8.34541667 0.805154759,8.34791667 0.909959184,8.34375 L26.8791973,8.34375 C26.9181511,8.34541667 26.9580325,8.34708333 26.9969863,8.34791667 Z M26.9969456,17.0979167 C27.1008259,17.1104167 27.1277235,17.1104167 27.2297488,17.13375 C27.4968695,17.19625 27.7408026,17.33125 27.9235206,17.5179167 C28.2666965,17.86875 28.3640843,18.37625 28.1702363,18.8095833 C28.1118036,18.94125 28.0274009,19.0629167 27.9235206,19.1695833 C27.8196403,19.27625 27.695355,19.36625 27.5580846,19.4354167 C27.4198868,19.50375 27.2696314,19.5520833 27.1147385,19.5754167 C27.0108582,19.5920833 26.9839606,19.5895833 26.8791528,19.59375 L0.909084052,19.59375 C0.804276275,19.5895833 0.777378703,19.5920833 0.674425931,19.5754167 C0.401740208,19.53375 0.14574953,19.4179167 -0.0536634978,19.24625 C-0.138993724,19.1729167 -0.21319392,19.0895833 -0.275336585,18.99875 C-0.505357194,18.6645833 -0.5452398,18.2420833 -0.381999367,17.8779167 C-0.32263921,17.74625 -0.239163989,17.6245833 -0.135283714,17.5179167 C-0.0314034388,17.41125 0.0928818904,17.32125 0.230152254,17.2520833 C0.36835012,17.18375 0.518605518,17.1354167 0.674425931,17.1120833 C0.777378703,17.0954167 0.804276275,17.0979167 0.909084052,17.09375 L26.8791528,17.09375 C26.9181079,17.0954167 26.9579905,17.0970833 26.9969456,17.0979167 Z" id="Combined-Shape"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </template>

                                    <b-dropdown-item href="/marketplace/index" >
                                         {{t('Marketplace')}}

                                    </b-dropdown-item>
                                    <b-dropdown-item :href="'/'+catalogue.category_path" v-for="catalogue in catalogues">
                                        {{catalogue.category_name}}
                                    </b-dropdown-item>
                                </b-dropdown>

                    <div id="navbar-collapse-1" class="navbar-collapse collapse">
                        <ul class="nav navbar-nav head-menu">
                            <li>
                                <a href="#" @click.stop.prevent="$emit('open-login')">{{t('Log-in')}}</a>
                            </li>
                            <li v-if="$parent.corporation.marketplace_show_register">
                                <a href="#" @click.stop.prevent="$emit('open-signup')">{{t('Register')}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <a :href="getLogoHREF()"
                   class="d-inline-block"
                   v-if="!showMobileSearch">
                    <img :src="$parent.corporation.logo" class="img-responsive logo">
                </a>
                  
                <ul v-if="showCategoriesMenu && pathCatalogueMenu === 1"
                    class="ml-3 list-inline d-none d-sm-none d-md-inline-block" >                 
                   <li class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id" :catalogue_name="catalogue_name" :key="idMenuCategory" :label_category_catalogue="labelCategoryCatalogue"
                                         :category-type="CATEGORIES_TYPES.CATEGORY">
                        </categories-menu>
                    </li>
                    <li class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id" :catalogue_name="catalogue_name" :key="idMenuHost" :label_category_catalogue="labelCategoryCatalogue"
                                         :category-type="CATEGORIES_TYPES.HOST">
                        </categories-menu>
                    </li>
                    <li class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id" :catalogue_name="catalogue_name" :key="idMenuCompetence" :label_category_catalogue="labelCategoryCatalogue"
                                         :category-type="CATEGORIES_TYPES.COMPETENCES">
                        </categories-menu>
                    </li>                               
                </ul>
                 <ul v-else-if="showCategoriesMenu && pathCatalogueCI === 1"
                    class="ml-3 list-inline d-none d-sm-none d-md-inline-block" >                 
                    <li v-if="themeConfig.host" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.HOST">
                        </categories-menu>
                    </li>
                    <li v-if="themeConfig.competences" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.COMPETENCES">
                        </categories-menu>
                    </li>                    
                </ul>
                <ul v-else-if="showCategoriesMenu && pathCatalogueCC === 1"
                    class="ml-3 list-inline d-none d-sm-none d-md-inline-block" >                 
                     <li v-if="themeConfig.category" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.CATEGORY">
                        </categories-menu>
                    </li>              
                </ul>
                <ul v-else-if="showCategoriesMenu"
                    class="ml-3 list-inline d-none d-sm-none d-md-inline-block" >
                    <li v-if="themeConfig.category" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.CATEGORY">
                        </categories-menu>
                    </li>
                    <li v-if="themeConfig.host" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.HOST">
                        </categories-menu>
                    </li>
                    <li v-if="themeConfig.competences" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.COMPETENCES">
                        </categories-menu>
                    </li>
                     <li v-if="idCorporation == 298 && themeConfig.formats" class="list-inline-item">
                        <categories-menu :corporation-id="$parent.corporation.id"
                                         :category-type="CATEGORIES_TYPES.FORMATS">
                        </categories-menu>
                    </li>
                </ul>
                
            </div><!-- .header -->

            <div class="d-block d-sm-none btn-header" v-if="isLearner || isAdminUser">
                <a :href="EVENTS_LINK()" class="btn btn-orange btn-orange-m">{{t('My Events')}}</a>
            </div><!-- My Events Mobile -->
        </div><!-- .course -->
    </div>
</template>

<script>
import API from '@/api/index';
import SessionManageMixin from "@/mixins/SessionManageMixin";
import ApplicationMixin from '@/mixins/ApplicationMixin';

import { CATEGORIES_TYPES, } from '@/utils';
import CategoriesMenu from './CategoriesMenu';
import CloseIcon from "../Icons/CloseIcon";
import CatalogueIcon from '@/components/Icons/CatalogueIcon';

export default {
    mixins: [
      SessionManageMixin,
      ApplicationMixin,
    ],
    name: "MainHeader",
    props: {
        showBanner: {
            type: Boolean,
            default() {
                return false;
            }
        },
        bannerHidden: {
            type: Boolean,
            default() {
                return false;
            }
        },
        disableAccessibility: {
            type: Boolean,
            default() {
                return false
            }
        },
        catalogues: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            showMobileSearch: !!this.keyword,
            showSearch: false,
            keyword: '',
            isLoggedIn: false,
            cartCount: 0,
            src: '',
            openSignUp: false,
            fontIncreased: false,
            showDefaultMarketplace : false,
            show_my_preferences : SHOW_MY_PREFERENCES=='1'?true:false,
            userData:{
                profileImage: ''
            },
            catalogue_name: '',   
            idMenuHost: 0,
            idMenuCategory: 0,
            idMenuCompetence: 0,            
            labelCategoryCatalogue: []
        }
    },
    components: {
        CloseIcon,
        CategoriesMenu,
        CatalogueIcon,
    },
    computed: {
        _() {
            return _;
        },
       pathCatalogueMenu(){
             var catalogue_path = [];
            if(CATALOGUE_PATH)
              catalogue_path = CATALOGUE_PATH.split("/");
            else
              return 0;

            console.log("pathCatalogueCI en el computed : ", catalogue_path);
                            
            if(this.idCorporation === 571 && catalogue_path[1]==="capacitacion-interna"){
                return 0;
            }
            else{
                if(catalogue_path[1] && catalogue_path[1]!= 'marketplace'){
                    this.catalogue_name = catalogue_path[1];
                    this.getLabelCategoryCatalogue();
                    return 1
                }                  
            }

            return 0;
        },
        pathCatalogueCI(){
            var catalogue_path = [];
            if(CATALOGUE_PATH)
              catalogue_path = CATALOGUE_PATH.split("/");
            else
              return 0;

            console.log("pathCatalogueCI en el computed : ", catalogue_path);
                            
            if(this.idCorporation === 571 && catalogue_path[1]==="capacitacion-interna"){
                return 1;
            }

            return 0;
        },
        pathCatalogueCC(){          
                            
            if(this.idCorporation === 571){
                return 1;
            }

            return 0;
        },
        user() {
            return this.$parent.user;
        },
        idCorporation() {
          return this.corporationInfo ? this.corporationInfo.id_corporation : 0;
        },
        showCategoriesMenu() {
            return Object.values(this.themeConfig).indexOf(true) > -1;
        },
        themeConfig() {
            let themeConfig = _.get(this.$parent, 'corporation.menu_top_filters', null);           
            return themeConfig ? JSON.parse(themeConfig) : {};
        },
        isAdminUser() {
            return _.get(this.user, 'ACL.Course.Create', 0) === 1;
        },
        isOwner() {
            return _.get(this.user, 'level_access', 0) === 1;
        },
        isCourseManager() {
            return _.get(this.user, 'level_access', 0) === 6 || _.get(this.user, 'level_access', 0) === 2;
        },
        isExternalInstructor() {
            return _.get(this.user, 'level_access', 0) === 7;
        },
        showManage(){
        	return _.get(this.user, 'ACL.CourseModule.AddModule', 0) === 1 || this.isAdminUser
        },
        showApplicationsOption(){
        	return _.get(this.user, 'ACL.Course.Create', 0) === 1 && this.idCorporation == 227;
        },
        isLearner() {
            return _.get(this.user, 'level_access', 0) === 3;
        },
        corporationStylesBorderTop() {
            let styles = {};
            const filtersColor = _.get(this.$parent, 'corporation.color_filters', null);

            if (filtersColor) {
                styles.borderTopColor = filtersColor;
            }

            return styles;
        },
        CATEGORIES_TYPES() {
            return CATEGORIES_TYPES;
        },
        corporationShowQuicksight() {
            const showquicksightanalytics = _.get(this.$parent, 'corporationInfo.show_quicksight_analytics', null);
            return showquicksightanalytics;
        },
        publicCatalogues() {
            return this.catalogues.filter(c=>!JSON.parse(c.category_privacy) && !c.deletedAt && !!JSON.parse(c.active));
        },
    },
    methods: {
        async getLabelCategoryCatalogue(){   
                       
                const response =   await API.domain.getLabelCategoryCatalogue(this.catalogue_name, this.idCorporation);
                                 
                if(response){
                        this.labelCategoryCatalogue = response.data.labelCategoryCatalogue;               
                        this.idMenuHost = this.idMenuHost +1;
                        this.idMenuCategory = this.idMenuCategory +1;
                        this.idMenuCompetence = this.idMenuCompetence +1;
                        this.$forceUpdate(); 
                }             
          
        },
        async getUserCrud(){
            if(this.$parent.isLoggedIn) {
                const response =   await API.domain.crudDataUser({
                    body: {
                        id_user : 0
                    }
                });
                let profileImage = response.data.User.profile_picture;

                if(profileImage){
                    this.userData.profileImage = '/files/profile/' + profileImage
                }else{
                    this.userData.profileImage = '/webroot/images/user_placeholder.jpg';
                }
            }
        },        
    	getLogoHREF(){

    		return CATALOGUE_PATH ? CATALOGUE_PATH.substring(0, CATALOGUE_PATH.length - 1) : "/marketplace/list"

    	},
        increaceFont() {
            this.$refs.fontUpBtn.click();
            this.fontIncreased = true;
        },
        resetFont() {
            this.$refs.resetBtn.click();
            this.fontIncreased = false;
        },
        increaseFont() {
            window.agastya.api('customize', { fontSize: 110 });
        },
        mobileSearchAction() {
            if (this.showMobileSearch) {
                this.doSearch({keyword: this.keyword}, true)
            } else {
                this.showMobileSearch = true;
            }
        },
        async logoutAction() {

            if(_.get(this.$parent.corporation, 'show_oauth_login', false)) {
                window.location.href = this.$parent.logoutUrl;
            } else {
                this.$parent.isLoggedIn = false;
                await API.phpAppEndpoints.doLogout();
                location.reload();
                //window.location.href = PAGES.LIST;
                await this.$parent.stayAlive();
            }
        },
        doSearch() {

        },
        closeBetaBanner() {
            this.$emit('hide-banner');
        },
        getCataloguePath(catalogue) {
            return `/${catalogue.category_path||catalogue.category_name.replace(/[^\w ]/g, '').replace(/ /g, '-').toLowerCase()}`;
        },EVENTS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/my_courses` : `/apprendo/dashboard#/my_courses`;
        },
        CREATES_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/createCourse` : `/apprendo/dashboard#/createCourse`;
        },
        MANAGES_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/search/courses` : `/apprendo/dashboard#/search/courses`;
        },
        ANALITICS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/AnalyticsEmbed` : `/apprendo/dashboard#/AnalyticsEmbed`;
        },
        ANALITICS2_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/analyticsembedcoursemanagers` : `/apprendo/dashboard#/analyticsembedcoursemanagers`;
        },
        DOMAINS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/myapprendo` : `/apprendo/dashboard#/myapprendo`;
        },
        PREFERENCES_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/my_preferences/preferences` : `/apprendo/dashboard#/my_preferences/preferences`;
        },
        FAVORITS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/my_preferences/favorites` : `/apprendo/dashboard#/my_preferences/favorites`;
        },
        APLICATIONS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/myApplications/` : `/apprendo/dashboard#/myApplications/`;
        },
        PROFILES_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/myProfile` : `/apprendo/dashboard#/myProfile`;
        },
        ORDERS_LINK() {
            return CATALOGUE_PATH  ? `/apprendo/dashboard${CATALOGUE_PATH}#/myorders` : `/apprendo/dashboard#/myorders`;
        },
    },    
    mounted() {  
        this.getUserCrud();
    	this.showDefaultMarketplace = SHOW_MARKETPLACE_CATALOGUE
    	this.$translate.setLang('spanish');
        this.$nextTick(() => {
            $('.text-to-increase').jfontsize({
                selector: '.text-to-increase',
                btnMinusClasseId: '#jfontsize-m2', // Defines the class or id of the decrease button
                btnDefaultClasseId: '#jfontsize-d2', // Defines the class or id of default size button
                btnPlusClasseId: '#jfontsize-p2', // Defines the class or id of the increase button
                btnMinusMaxHits: 1, // How many times the size can be decreased
                btnPlusMaxHits: 1, // How many times the size can be increased
                sizeChange: 25 // Defines the range of change in pixels
            });
        });
    }
}
</script>

<style scoped>
    .avatar-img {
        width: 30px;
        height: 30px;
        max-width: 30px;
        max-height: 30px;
    }

    .acc-btn-li {
        margin-top: 10px;
        cursor: pointer;
        margin-right: 20px;
    }
    .my-name{
      width: 125px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      line-height: 16px;
    }
</style>


<style>
    .fontBtn .tooltip-inner {
        max-width: 300px !important;
    }

    .fontBtn p {
        font-size: 18px !important;
        margin: 0 !important;
    }

    .user-menu button.dropdown-toggle:focus,
    .user-menu button.dropdown-toggle:active,
    .user-menu button.dropdown-toggle:hover,
    .user-menu button.dropdown-toggle {
        background-color: transparent !important;
        border: none;
        color: #383838 !important;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        cursor: pointer;
    }

    .user-menu a.dropdown-item:active,
    .user-menu button.dropdown-item:active,
    .user-menu a.dropdown-item,
    .user-menu button.dropdown-item {
        cursor: pointer;
        color: #383838 !important;
        font-size: 16px;

        text-decoration: none;
        background-color: white !important;
    }

    .fixed-header-wrapper {
        background-color: white;
        top: 0;
        z-index: 5;
    }

    .beta-banner {
        background-color: #00AEEF;
        padding: 10px 50px;
    }

    .beta-banner a,
    .beta-banner p {
        color: white !important;
        margin-bottom: 0;
    }

    .beta-banner a {
        text-decoration: underline !important;
        font-size: 18px;
    }

    .close .fa,
    .close {
        color: white;
        opacity: 1;
    }

    .close {
        position: absolute;
        right: 20px;
        top: 10px;
    }

    .header-container .dropdown-menu {
        border-color: #256AB3;
        padding: 0px;
        margin: 0px;
    }

    .dropdown-menu:before {
        border-bottom: 13px solid #256AB3;
        border-left: none;
        border-right: none;
        content: "";
        height: 0;
        position: absolute;
        top: -13px;
        width: 0;
        left: 25%;
    }

    .dropdown-menu:after {
        border-bottom: 14px solid #fff;
        border-left: none;
        border-right: none;
        content: "";
        height: 0;
        position: absolute;
        border-bottom: 14px solid #fff;
        top: -12px;
        width: 0;
        left: 25%;
    }

    .user-menu .dropdown-menu:before,
    .user-menu .dropdown-menu:after {
        left: 50% !important;
    }

    .header-container .dropdown-menu.show {
        top: 10px !important;
    }

    .header-container .user-menu .dropdown-menu.show {
    }

    .header-container .dropdown-menu .dropdown-item {
      padding-left: 15px!important;
      min-height: 32px;
      line-height: 32px;
    }

    .header-container .dropdown-menu .dropdown-item:hover {
        text-decoration: none;
        background-color: #e3e5e8!important;
    }

    .header-container .dropdown-divider {
        border-top-color: #E9E9E9 !important;
        margin-top: 2px;
        margin-bottom: 2px;
    }

    .header-container .dropdown-toggle::after {
        display: none !important;
    }

    .header-container .user-menu button.dropdown-toggle {
        box-shadow: none !important;
    }
    
    .header-container .user-menu .dropdown-menu b-dropdown-text .user-card{
      display: block;
    }

    .header-container .user-menu .dropdown-menu b-dropdown-text .user-card,
    .header-container .user-menu .dropdown-menu .user-card .b-dropdown-text{
      padding: 0px;
      margin: 0px;
      padding-left: 15px!important
    }
   .header-container .user-menu .dropdown-menu{
      min-width: 268px;
   }
   .header-container .user-menu .dropdown-menu .b-dropdown-text,
   .header-container .user-menu .dropdown-menu .dropdown-item{
      margin: 0px;
      padding: 0px;
    }
    .header-container .user-menu .dropdown-menu .role-secction,
    .header-container .user-menu .dropdown-menu .user-card,
    .header-container .user-menu .dropdown-menu li,
    .header-container .user-menu .dropdown-menu p,
    .header-container .user-menu .dropdown-menu a{
      padding: 0px;
      margin: 0px;
      text-decoration: none;
    }
    .header-container .user-menu .dropdown-menu b-dropdown-text{
      display: block;
    }

    .header-container .user-menu .dropdown-menu b-dropdown-text,
    .header-container .user-menu .dropdown-menu .b-dropdown-text{
      height: 16px;
      font-size: 12px;
      color: #9fa5ac;
      text-decoration: none solid rgb(159, 165, 172);
      line-height: 16px;
      padding-left: 18px;
    }
    .header-container .user-menu .dropdown-menu .user-card .a-img{
      width: 48px;
      height: 48px;
      margin: 0.8em 0 0 0.5em;
      display: inline-flex;
    }
    .header-container .user-menu .dropdown-menu .logout{
      height: 40px;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      text-align: center;
    }
    .header-container .dropdown-menu .dropdown-item.logout,
    .header-container .dropdown-menu .logout .dropdown-item {
      padding-left: 0px!important;
      min-height: 40px;
      line-height: 35px;
      background-color: #f5f6f8!important;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      font-size: 16px;
      text-align: center;
      border-top: 1px solid #9fa5ac;
      margin-bottom: 1px;
    }

    .header-container .dropdown-menu .logout:hover,
    .header-container .dropdown-menu .logout .dropdown-item:hover{
      background-color: #e3e5e8!important;
    }
    .header-container .user-menu .dropdown-menu .user-card .a-img:hover .avatar-img{
      -webkit-filter: brightness(70%);
      -webkit-transition: all 1s ease;
      -moz-transition: all 1s ease;
      -o-transition: all 1s ease;
      -ms-transition: all 1s ease;
      transition: all 1s ease;
    }
    .header-container .user-menu .dropdown-menu .user-card a .avatar-img{
      width: 48px;
      height: 48px;
      max-width: 48px;
      max-height: 48px;
      border: 1px solid #fff;
      -webkit-filter: brightness(100%);
    }
    .header-container .user-menu .dropdown-menu .user-card div{
      display: inline-block;
      width: 66%;
      top: 15px;
      position: absolute;
      right: 0;
    }
    .header-container .user-menu .dropdown-menu .user-card div{
      font-size: 18px;
      line-height: 20px;
      text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
      font-weight: bold;
    }
    .header-container .user-menu .dropdown-menu .user-card div a{
      text-decoration: underline;
    }
    .header-container .user-menu .dropdown-menu .user-card div span{
      font-size: 14px;
      text-decoration: none solid rgb(255, 255, 255);
      text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
      font-weight: normal;
    }
    .header-container .dropdown-menu {
      border: none;
      padding: 0;
      margin: 0;
      box-shadow: -3px 3px 12px rgb(56 56 56 / 50%);
    }
    .header-container .user-menu .dropdown-menu .divider{
      padding: 0 16px;
    }
     /* Smartphones (portrait and landscape) ----------- */
    @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
        .header-container .user-menu .dropdown-menu.show {
            left: 0 !important;
            transform: translate3d(-90px, 36px, 0px) !important;
        }

        .user-menu .dropdown-menu:after, .user-menu .dropdown-menu:before {
            left: 65% !important;
        }
    }

    /** MY EVENTS BUTTON AND FIXES TO DESIGN **/
    .btn.btn-orange {
        background-color: rgb(231, 106, 32);
        box-shadow: 0px 4px 8px rgba(231,106,32,0.5);
        color: rgb(255, 255, 255) !important;
        font-family: 'Source Sans Pro';
        font-size: 16px !important;
        line-height: 22px;
        margin: 11px;
        padding: 8px 11px !important;
        text-align: center !important;
        width: 119px;
    }

    .btn.btn-orange:hover,
    .btn.btn-orange:active,
    .btn.btn-orange:focus {
        background-color: rgb(184, 84, 25);
        text-decoration: none !important;
    }

    .btn-orange.btn-orange-m {
        display: block;
        margin: 11px 18px;
        padding: 4px 16px !important;
        width: inherit;
    }

    .btn-header {
        height: 54px;
        left: 0px;
        position: fixed;
        right: 0px;
        top: 86px;
    }

    .btn-separator {
        border-left: 1px solid rgb(233,233,233);
        display: inline-block;
        height: 60px;
        width: 1px;
    }

    .course .header {
        border-bottom-width: 1px;
    }

    .btn-catalogues {
        margin: 11px;
    }

    .btn-user-menu {
        margin: 10px 11px;
    }

    .btn-user-menu img.avatar-img {
        text-indent: -9999px;
    }

    @media (max-width: 575px) {
        .fixed-header-container-padding {
            padding-top: 140px !important;
        }
        .header-container .user-menu .dropdown-menu.show {
            position: fixed;
            transform: translate3d(0px, 42px, 0px) !important;
            left: 0px!important;
            position: fixed!important;
            top: 42px!important;
        }
        .fixed-header-container-padding .fixed-header-wrapper,
        .fixed-header-container-padding .fixed-header-wrapper .container-top-line {
            height: 140px;
        }

        .header.fixed-mobile {
            height: 80px;
        }

        .btn-catalogues {
            margin: 12px 11px;
        }

        .header .logo {
            margin: 6px 0px;
        }
    }
</style>